module.exports = __webpack_public_path__ + "img/20200304152553582.d9e5a3ac.jpg";